module.exports = __webpack_public_path__ + "static/media/ventor-list.939c74a4.png";